var login = {
  translation: {
    common: {
      accept: '수락',
      alreadyUser: '이미 사용자입니까?',
      and: '및',
      backToLogin: '로그인 페이지로 돌아가기',
      continueWith: '{{provider}}로 계속',
      createAccount: '계정 생성',
      createYourAccount: '계정을 생성하세요',
      emailOrUsername: '이메일 또는 사용자 이름',
      login: '로그인',
      logIn: '로그인',
      logInToBoards: '로그인',
      newToBoards: 'Viki Teams 처음이신가요?',
      pageNotFound_title: '페이지를 찾을 수 없습니다',
      password: '비밀번호',
      privacyPolicy: '개인정보처리방침',
      register: '회원가입',
      registerWithGoogle: 'Google로 가입',
      termsOfService: '이용약관',
      togglePasswordVisibility: '비밀번호 표시/숨김',
    },
  },
};

export { login as default };
